/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { withStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import MuiDialogTitle from '@material-ui/core/DialogTitle'
import MuiDialogContent from '@material-ui/core/DialogContent'
import MuiDialogActions from '@material-ui/core/DialogActions'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import Typography from '@material-ui/core/Typography'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'

import { useDispatch, useSelector } from 'react-redux'
import { createShipping, updateShipping } from '../../actions/shippingActions'
import { useSnackbar } from 'react-simple-snackbar'

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    backgroundColor: '#1976D2',
    marginLeft: 0,
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: 'white',
  },
})

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  )
})

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
}))(MuiDialogContent)

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions)

const AddShipping = ({ setOpenShipping, openShipping, currentId, setCurrentId }) => {
  const location = useLocation()
  const formRef = useRef()
  const [shippingData, setShippingData] = useState({
    name: '',
    charges: '',
    country: '',
    status: true,
    userId: 0,
  })
  const [user, setUser] = useState(JSON.parse(localStorage.getItem('profile')))
  const dispatch = useDispatch()
  const shipping = useSelector((state) =>
    currentId ? state.shipping.shippings.find((item) => item.id === currentId) : null,
  )
  // eslint-disable-next-line
  const [openSnackbar, closeSnackbar] = useSnackbar()

  useEffect(() => {
    if (shipping && currentId !== null) {
      setShippingData(shipping)
    } else {
      setShippingData({
        name: '',
        charges: '',
        country: '',
        isActive: true,
        userId: 0,
      })
    }
  }, [shipping])

  useEffect(() => {
    setUser(JSON.parse(localStorage.getItem('profile')))
    setShippingData({ ...shippingData, userId: user?.result?.id })
  }, [location])

  useEffect(() => {
    const checkId = user?.result?.id
    if (checkId !== undefined) {
      setShippingData({ ...shippingData, userId: checkId })
    }
  }, [location])

  const handleSubmitShipping = (e) => {
    e.preventDefault()

    if (shippingData.name === '') {
      openSnackbar('Name is required')
      return
    }

    if (shippingData.charges === '' || Number(shippingData.charges) < 0) {
      openSnackbar('Charges must be a valid positive number')
      return
    }

    if (shippingData.country === '') {
      openSnackbar('Country is required')
      return
    }

    if (currentId) {
      dispatch(updateShipping(currentId, shippingData, openSnackbar))
    } else {
      dispatch(createShipping(shippingData, openSnackbar))
    }

    clear()
    handleClose()
  }

  const clear = () => {
    if (setCurrentId) {
      setCurrentId(null)
    }
    setShippingData({
      name: '',
      charges: '',
      country: '',
      isActive: true,
      userId: 0,
    })
  }

  const handleClose = () => {
    setOpenShipping(false)
  }

  const inputStyle = {
    display: 'block',
    padding: '1.4rem 0.75rem',
    width: '100%',
    fontSize: '0.8rem',
    lineHeight: 1.25,
    color: '#55595c',
    backgroundColor: '#fff',
    backgroundImage: 'none',
    backgroundClip: 'padding-box',
    borderTop: '0',
    borderRight: '0',
    borderBottom: '1px solid #eee',
    borderLeft: '0',
    borderRadius: '3px',
    transition: 'all 0.25s cubic-bezier(0.4, 0, 1, 1)',
  }

  return (
    <div>
      <form ref={formRef}>
        <Dialog
          onClose={(e, reason) => {
            if (reason !== 'backdropClick') {
              handleClose()
            }
          }}
          aria-labelledby="customized-dialog-title"
          open={openShipping}
          fullWidth
        >
          <DialogTitle id="customized-dialog-title" onClose={handleClose} style={{ paddingLeft: '20px', color: 'white' }}>
            {currentId ? 'Edit Shipping' : 'Add New Shipping'}
          </DialogTitle>
          <DialogContent dividers>
            <div className="customInputs">
              <input
                placeholder="Name"
                style={inputStyle}
                name="name"
                type="text"
                onChange={(e) => setShippingData({ ...shippingData, name: e.target.value })}
                value={shippingData.name}
              />
              <input
                placeholder="Charges"
                style={inputStyle}
                name="charges"
                type="number"
                step="0.01"
                min="0"
                onChange={(e) => setShippingData({ ...shippingData, charges: e.target.value })}
                value={shippingData.charges}
              />
              <Select
                style={inputStyle}
                name="country"
                onChange={(e) => setShippingData({ ...shippingData, country: e.target.value })}
                value={shippingData.country}
                displayEmpty
              >
                <MenuItem value="" disabled>
                  Select Country
                </MenuItem>
                <MenuItem value="United States">United States</MenuItem>
                <MenuItem value="Canada">Canada</MenuItem>
                <MenuItem value="United Kingdom">United Kingdom</MenuItem>
              </Select>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={Boolean(shippingData.isActive)}
                    onChange={(e) => setShippingData({ ...shippingData, isActive: e.target.checked })}
                    name="isActive"
                    color="primary"
                  />
                }
                label="Active"
              />
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleSubmitShipping} variant="contained" style={{ marginRight: '25px' }}>
              Save Shipping
            </Button>
          </DialogActions>
        </Dialog>
      </form>
    </div>
  )
}

export default AddShipping
